export class AdminReinstallLiveHubRequest {
    LicenseKey: string;
}
